export const PARENT_MERGE_FIELDS = [
  "firstName",
  "lastName",
  "email",
  "phone",
  "address",
  "zipCode",
  "city",
];

export const mergeParentFields = (target, source, choices = {}) => {
  const hasTarget = target && typeof target === "object" && Object.keys(target).length > 0;
  const merged = { ...(hasTarget ? target : source || {}) };
  Object.keys(choices || {}).forEach((field) => {
    merged[field] = choices[field] === "new" || !hasTarget ? source?.[field] : target?.[field];
  });
  return merged;
};

export const stripUnwantedParentFields = (parent) => {
  if (!parent || typeof parent !== "object") return {};
  const { keycloakId, ...rest } = parent;
  return rest;
};

export const pickMergeableParentFields = (parent) =>
  PARENT_MERGE_FIELDS.reduce((result, field) => {
    const value = parent?.[field];
    if (
      value === null ||
      value === undefined ||
      ["string", "number", "boolean"].includes(typeof value)
    ) {
      result[field] = value;
    }
    return result;
  }, {});
